import script from "./ExecutiveMemberPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ExecutiveMemberPage.vue?vue&type=script&setup=true&lang=js"

import "./ExecutiveMemberPage.vue?vue&type=style&index=0&id=d60b83be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d60b83be"]])

export default __exports__